import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ApiTwoToneSvg from "@ant-design/icons-svg/es/asn/ApiTwoTone";
import AntdIcon from "../components/AntdIcon";
var ApiTwoTone = function ApiTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ApiTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ApiTwoTone.displayName = 'ApiTwoTone';
}
export default /*#__PURE__*/React.forwardRef(ApiTwoTone);